import { useConnectionStateChangeDispatcher } from "../hooks/useConnectionStateChangeDispatcher";

/**
 * Add signalR connection changes to inbox state
 */
export const ConciergeConnectionStateChangeInitializer = () => {
    useConnectionStateChangeDispatcher();
    return null;
};
